import { type AxiosInstance } from 'axios'

type UserUpdatedPermission = {
  permission_name: string
  app_label: string
  checked: boolean
  email: string
}

export default (axios: AxiosInstance) => ({
  async userIsAbleTo(action: string, resource: string) {
    const { data } = await this.listUsersPermissions()
    return data[resource][action]
  },
  async userIsAbleToMultiple(
    resourceActions: Array<{ action: string, resource: string }>,
  ) {
    const { data } = await this.listIndividualPermissions()
    return [...resourceActions].map(({ resource, action }) => {
      return data[resource][action]
    })
  },

  listUsersPermissions(company = null) {
    const companyId = localStorage.getItem('cid')
    return axios.get(`/v1/permissions/get_user_permissions&company=${companyId || company}`)
  },
  listIndividualPermissions(company = null) {
    const companyId = localStorage.getItem('cid')
    return axios.get(`/v1/permissions/get_user_permissions/company/${company || companyId}/individual/`)
  },
  updateUserPermissions(
    companyId: number | string,
    updateData: Array<UserUpdatedPermission>,
  ) {
    return axios.put(
      `/v1/permissions/update_user_permissions&company=${companyId}/`,
      updateData,
    )
  },
})
